import * as Immutable from 'immutable';
import * as ActionTypes from '../constants/ActionTypes';

const socialState = Immutable.fromJS({
  deals: {
    defaultDivisor: .5
  },
  limit: 3,
  new: {
    type: null,
    nav: false
  },
  loading: {
    new: false
  }
});

function setState(state, newState) {
  return state.merge(newState);
}

export function social(state = socialState, action) {
  switch(action.type) {
    case ActionTypes.LOADING_POST:
      return setState(state, state.setIn(['loading', 'new'], action.payload));

    case ActionTypes.NEW_POST:
      return setState(state, state.setIn(['new', 'type'], action.payload));

    case ActionTypes.TOGGLE_NAV:
      return setState(state, state.setIn(['new', 'nav'], action.payload));

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/social.js